import React from 'react';
import { translate } from 'react-i18next';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';

class NameAndSelectVariety extends React.Component {

  selectItemsStands(stands) {
    return this.props.stands.map((stand) => (
      <MenuItem
        value={stand.key}
        insetChildren={true}
        key={stand.key}
        primaryText={stand.name}
        checked={stands && stands.indexOf(stand.key) > -1} />
    ));}

  selectItemsProducts(products) {
    return this.props.products.map((product) => (
      <MenuItem
        value={product.key}
        insetChildren={true}
        key={product.key}
        primaryText={product.name}
        checked={products && products.indexOf(product.key) > -1} />
    ));}

  render()  {
    const {t} = this.props;

    return (
      <div className="col-xs col-md-7">
        <TextField
          hintText={t('offer.name')}
          floatingLabelText={t('offer.name')}
          onChange={this.props.handleNameChange}
          value={this.props.name}
          onBlur={this.props.validateName}
          errorText={this.props.nameError}
        />
        <br />
        <SelectField
          hintText={t('offer.allStands')}
          floatingLabelText={t('stand.stands')}
          floatingLabelFixed={true}
          value={this.props.offerStands}
          onChange={this.props.handleStandChange}
          multiple={true}
          autoWidth={true}>
          {this.selectItemsStands(this.props.offerStands)}
        </SelectField>
        <br />
        <SelectField
          hintText={t('offer.allProducts')}
          floatingLabelText={t('product.products')}
          floatingLabelFixed={true}
          value={this.props.offerProducts}
          onChange={this.props.handleProductChange}
          multiple={true}
          autoWidth={true}>
          {this.selectItemsProducts(this.props.offerProducts)}
        </SelectField>
        <div className='paddingDiv'/>
      </div>
    );
  }
}

export default translate()(NameAndSelectVariety);



// WEBPACK FOOTER //
// ./src/Offer/NameAndSelectVariety.js